import React from "react";
import Highcharts from "highcharts/highstock";
import PieChart from "highcharts-react-official";
import {
  forToFix,
  numDifferentiation,
} from "../../../CommonMethhods/CovertRupees";
import { Constants } from "../../../CommonMethhods/Constants";
import SmallLoader from "../../Common/smallLoader";
// import pieChart from "../../../asset/images/png/pie-chart.png";

function NetEquityPortfolio(props) {
  const equityLoader = props.netEquityLoader;
  const equityPortfolio = props.netEquityPortfolio;
  const HoldingPer =
    equityPortfolio.holdPer === undefined || null
      ? "-"
      : equityPortfolio.holdPer;
  const PositionPer =
    equityPortfolio.posPer === undefined || null ? "-" : equityPortfolio.posPer;

  const Total = HoldingPer + PositionPer;

  const holdingPlot = (HoldingPer / Total) * 100;
  const positionPlot = (PositionPer / Total) * 100;

  const options = {
    chart: {
      type: "pie",
      height: 200,
      width: 200,
    },
    title: {
      text: null,
      align: "center",
      verticalAlign: "middle",
      y: 20,
    },
    tooltip: {
      pointFormat: `{series.name}: <b>{point.percentage:.1f}%</b>`,
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: false,
        },
        showInLegend: false,
      },
    },
    series: [
      {
        name: "",
        color: "#006600",
        lineWidth: 1,
        marker: {
          enabled: false,
          symbol: "circle",
          radius: 3,
          states: {
            hover: {
              enabled: true,
              lineWidth: 1,
            },
          },
        },
        data: [
          //  { name: "Holding", y: 18},
          //  { name: "Position", y: 20},

          {
            name: "Holding",
            y: holdingPlot,
            // sliced: true,
          },
          {
            name: "Position",
            y: positionPlot,
            // sliced: true,
          },
        ],
      },
    ],
    colors: ["#886CC0", "#FF86B1"],
  };
  return (
    <>
      <div className="col-12 col-lg-6">
        <div className="card-box portfolio">
          <div className="card-title">
            <div className="figure-inlac">
              <h2>{Constants.Net_Equity_Portfolio}</h2>
              {/* <p>{Constants.Figure_In_Lacs_for_all}</p> */}
            </div>
          </div>
          <div className="portfolio__data align-items-center">
            <div className="portfolio__details d-flex justify-content-between flex-column">
              <p className="values">
                {equityLoader ? (
                  <SmallLoader />
                ) : (
                  <>
                    {equityPortfolio.tot === undefined || null
                      ? "-"
                      : numDifferentiation(equityPortfolio.tot)}
                  </>
                )}
              </p>
              <div className="portfolio__bottom row">
                <div className="col-12">
                  <div className="portfolio__details__content">
                    <h6 className="gray-title">{Constants.Holdings}</h6>
                    <div className="values-wrapper">
                      <p className="values">
                        {equityLoader ? (
                          <SmallLoader />
                        ) : (
                          <>
                            {equityPortfolio.hold === undefined || null
                              ? "-"
                              : numDifferentiation(equityPortfolio.hold)}{" "}
                          </>
                        )}
                      </p>
                      <span className="holding-value">
                        {equityLoader ? (
                          <SmallLoader />
                        ) : (
                          <>
                            <i className="color-indicator"></i>
                            {forToFix(HoldingPer)} %
                          </>
                        )}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="portfolio__details__content">
                    <h6 className="gray-title">{Constants.Positions}</h6>
                    <div className="values-wrapper">
                      <p className="values">
                        {equityLoader ? (
                          <SmallLoader />
                        ) : (
                          <>
                            {equityPortfolio.pos === undefined || null
                              ? "-"
                              : numDifferentiation(equityPortfolio.pos)}{" "}
                          </>
                        )}
                      </p>
                      <span className="position-value">
                        {equityLoader ? (
                          <SmallLoader />
                        ) : (
                          <>
                            {" "}
                            <i className="color-indicator "></i>
                            {forToFix(PositionPer)} %
                          </>
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="portfolio-graph">
              <PieChart highcharts={Highcharts} options={options} />

              {/* <img src={pieChart} alt="" /> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NetEquityPortfolio;
